module.exports = __webpack_public_path__ + "img/BIT_white36.000b7ae9.jpg";